import React from 'react';

export default function PageHeading({eyebrow, title, description, children}) {
  return <header className="bb-page-heading">
    <div><p className="bb-kicker">{eyebrow}</p><h1>{title}</h1>{description && <p className="bb-page-description">{description}</p>}</div>
    {children && <div className="bb-heading-action">{children}</div>}
  </header>;
}
